import { render, staticRenderFns } from "./ContactsImport.vue?vue&type=template&id=c9d46ea6&scoped=true"
import script from "./ContactsImport.vue?vue&type=script&lang=js"
export * from "./ContactsImport.vue?vue&type=script&lang=js"
import style0 from "./ContactsImport.vue?vue&type=style&index=0&id=c9d46ea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d46ea6",
  null
  
)

export default component.exports